import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  setCurrentActiveSection,
  setActivationCode,
  checkoutAddressSubscriptionActivate,
  checkoutPaymentSubscriptionActivate,
  getActivationCodeCurrency
} from 'redux/actions/subscriptionActivate';
import {
  isTokenUnavailable
} from 'libs/auth';
import { sectionList, sectionHeader } from 'libs/subscriptionActivate';
import endPoints from 'config/routes/endpoints';
import ActivationCodeDetails from './ActivationCodeDetails';
import AccountDetails from './AccountDetails';
import AddressDetails from './AddressDetails';
import Payment from './Payment';
import ErrorBar from 'components/ErrorBar';

const checkCurrentSection = (section, currentActive) => currentActive === section;

class SectionWrapper extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errorBar: {
        show: false,
        message: ''
      },
    }
  }

  checkoutSuccess = () => {
    const { currentActive } = this.props.subscriptionActivate;
    if (currentActive === sectionList.accountDetails) {
      this.props.setCurrentSection(sectionList.addressDetails);
    } else if (currentActive === sectionList.addressDetails) {
      this.props.setCurrentSection(sectionList.payment);
    } else if (currentActive === sectionList.payment) {
      window.appHistory.push(endPoints.redemptionActivateSuccess);
    }
  }

  checkoutActivationCode = (activationCode) => {
    const { subscriptionActivate: { addressDetails: { info } } } = this.props;
    const addressInfo = info;
    let section = '';
    if (!activationCode) {
      section = sectionList.activationCode;
    } else if (activationCode && isTokenUnavailable()) {
      section = sectionList.accountDetails;
    } else if (activationCode && !isTokenUnavailable() && !addressInfo) {
      section = sectionList.addressDetails;
    } else if (addressInfo) {
      section = sectionList.payment;
    }
    this.props.setCurrentSection(section);
  }

  checkoutPayment = (token, cb) => {
    const {
      subscriptionActivate: {
        activationCode, addressDetails
      },
    } = this.props;
    const payload = {
      addressDetails,
      activationCode,
      token
    };
    this.props.checkoutPayment(payload, cb);
  }

  handleGetActivationCodeCurrency = (activationCode, cb = {}) => {
    this.props.getActivationCodeCurrency(
      activationCode,
      cb
    );
  }

  showErrorBar = ({ message }) => {
    const errorBar = {
      show: true,
      message
    };
    this.setState({ errorBar });
  }

  handleErrorBarClose = () => {
    const { errorBar } = this.state;
    if (errorBar.show) {
      const _errorBar = {
        show: false
      };
      this.setState({ errorBar: _errorBar });
    }
  }

  render() {
    const { errorBar } = this.state;
    const {
      subscriptionActivate:
      {
        currentActive, activationCode, addressDetails, payment
      },
      saveActivationCode, setCurrentSection, checkoutAddress
    } = this.props;
    return (
      <React.Fragment>
        <ErrorBar errorBar={errorBar} onClose={this.handleErrorBarClose} />
        <ActivationCodeDetails
          {...this.props}
          isActive={checkCurrentSection(sectionList.activationCodeDetails, currentActive)}
          currentSection={sectionList.activationCodeDetails}
          sectionHeader={sectionHeader.activationCodeDetails}
          activationCode={activationCode}
          setCurrentSection={setCurrentSection}
          setActivationCode={saveActivationCode}
          checkoutActivationCode={this.checkoutActivationCode}
          getActivationCodeCurrency={this.handleGetActivationCodeCurrency}
          showErrorBar={this.showErrorBar}
          closeErrorBar={this.handleErrorBarClose}
        />
        <AccountDetails
          {...this.props}
          isActive={checkCurrentSection(sectionList.accountDetails, currentActive)}
          currentSection={sectionList.accountDetails}
          setCurrentSection={setCurrentSection}
          sectionHeader={sectionHeader.accountDetails}
          activationCode={activationCode}
          checkoutSuccess={this.checkoutSuccess}
          showErrorBar={this.showErrorBar}
          closeErrorBar={this.handleErrorBarClose}
        />
        <AddressDetails
          {...this.props}
          isActive={checkCurrentSection(sectionList.addressDetails, currentActive)}
          currentSection={sectionList.addressDetails}
          sectionHeader={sectionHeader.addressDetails}
          setCurrentSection={setCurrentSection}
          addressDetails={addressDetails}
          checkoutAddress={checkoutAddress}
          checkoutSuccess={this.checkoutSuccess}
          showErrorBar={this.showErrorBar}
          closeErrorBar={this.handleErrorBarClose}
        />
        <Payment
          {...this.props}
          isActive={checkCurrentSection(sectionList.payment, currentActive)}
          currentSection={sectionList.payment}
          sectionHeader={sectionHeader.payment}
          payment={payment}
          setCurrentSection={setCurrentSection}
          checkoutPayment={this.checkoutPayment}
          checkoutSuccess={this.checkoutSuccess}
          getActivationCodeCurrency={this.handleGetActivationCodeCurrency}
          showErrorBar={this.showErrorBar}
          closeErrorBar={this.handleErrorBarClose}
        />
      </React.Fragment>
    );
  }
}

SectionWrapper.propTypes = {
  subscriptionActivate: PropTypes.object.isRequired,
  setCurrentSection: PropTypes.func.isRequired,
  saveActivationCode: PropTypes.func.isRequired,
  checkoutAddress: PropTypes.func.isRequired,
  checkoutPayment: PropTypes.func.isRequired,
};

function mapStateToProps({
  subscriptionActivate
}) {
  return {
    subscriptionActivate
  };
}

export default connect(mapStateToProps, {
  setCurrentSection: setCurrentActiveSection,
  saveActivationCode: setActivationCode,
  checkoutAddress: checkoutAddressSubscriptionActivate,
  checkoutPayment: checkoutPaymentSubscriptionActivate,
  getActivationCodeCurrency
})(SectionWrapper);



// WEBPACK FOOTER //
// ./src/views/SubscriptionActivate/SectionWrapper.jsx